<script setup lang="ts">
import { useTranslate } from '@tolgee/vue'
import { twMerge } from 'tailwind-merge'

withDefaults(defineProps<{
  imageClass?: string
  withTooltip?: boolean
}>(), {
  withTooltip: true,
  imageClass: '',
})

const { t } = useTranslate()
const tooltipText = t.value('user.telegram_premium_user', 'Telegram Premium User')
</script>
<template>
  <span>
    <img
      src="@/assets/images/premium.png"
      :class="twMerge('size-4 min-w-[16px]', imageClass)"
      v-tooltip="{content: tooltipText, placement: 'bottom', disabled: !withTooltip}"
    >
  </span>
</template>